import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Field, reduxForm, formValueSelector} from 'redux-form';
import {Button, ButtonToolbar} from 'reactstrap';
import renderSelectField from '../../../../shared/components/form/Select';
import LoadingIcon from 'mdi-react/LoadingIcon';
import withErrorNotification from '../../../../hof/withErrorNotification';
import {Posts} from '../../../../services/Posts';
import Notifications from '../../../../hof/notifications';
import {withRouter} from 'react-router-dom';
import {initCurrentBlog} from '../../../../redux/actions/blogsActions';
import {fetchPosts} from '../../../../redux/actions/postsActions';
import {fetchDrafts} from '../../../../redux/actions/draftsActions';
import {withTranslation} from "react-i18next";
import {translate} from "../../../../translations/i18n";

const selector = formValueSelector('import_posts')

class WizardFormImport extends Component {

    constructor() {
        super();
        this.state = {
            inProgress: false
        }
    }


    handleSubmit = async () => {

        if (!this.state.inProgress) {

            if (this.props.category) {

                this.setState({inProgress: true});
                console.log(this.props.category);
                await withErrorNotification(async () => {

                    const result = await Posts.importAll(this.props.blog._id, this.props.category.value)
                    Notifications.showNotification(translate('create.wizard.import.notifications.success.title'), `${translate('create.wizard.import.notifications.success.body')} :${result.total}`, Notifications.Colors.SUCCESS)
                    this.setState({inProgress: false});

                    this.props.initCurrentBlog(this.props.blog._id);
                    this.props.fetchDrafts(this.props.blog._id);
                    this.props.fetchPosts(this.props.blog._id);

                    setTimeout(() => {
                        this.props.history.push(`/`);
                    }, 400)
                }, () => {
                    this.setState({inProgress: false});
                });
            } else {
                Notifications.showNotification(translate('create.wizard.import.notifications.select_category.title'), translate('create.wizard.import.notifications.select_category.body'), Notifications.Colors.ERROR)
            }
        }
    }

    render() {

        const {t} = this.props;

        return (
            <form className="form form--horizontal wizard__form" onSubmit={(e) => {
                e.preventDefault()
            }}>
                <div className="form__form-group">
                    <h3 className="wizard__title">{t('create.wizard.import.import_previous_posts')}</h3>
                    <div className="form__form-group">
                        <p>{t('create.wizard.import.imported_posts_description')}</p>
                    </div>

                    <div className="form__form-group">
                        <span className="form__form-group-label">{t('create.wizard.import.desired_category')}</span>
                        <div className="form__form-group-field">
                            <Field
                                name="category"
                                component={renderSelectField}
                                type="text"
                                options={this.props.blog.categories.map(category => ({
                                    value: category._id,
                                    label: category.name
                                }))}
                                placeholder={translate('create.wizard.import.choose_category')}
                            />
                        </div>
                    </div>
                </div>
                <div className="form__form-group">
                    <ButtonToolbar className="form__button-toolbar wizard__toolbar">
                        <Button
                            color="primary"
                            outline={true}
                            className="expand expand--load"
                            disable={this.state.inProgress} onClick={() => {
                            this.props.history.push(`/`);
                        }}>{t('create.wizard.import.button_finish')}</Button>
                        <Button
                            color="primary"
                            className="expand expand--load"
                            onClick={this.handleSubmit}>
                            {this.state.inProgress && <LoadingIcon/>}
                            {t('create.wizard.import.button_import')}
                        </Button>

                    </ButtonToolbar>
                </div>
            </form>
        )
    }
}

const mapStateToProps = (state) => {
    const category = selector(state, 'category')
    return {
        category,
        blog: state.blogs.blog
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        initCurrentBlog: (blogId) => dispatch(initCurrentBlog(blogId)),
        fetchDrafts: (blogId) => dispatch(fetchDrafts(blogId)),
        fetchPosts: (blogId) => dispatch(fetchPosts(blogId))
    }
}

WizardFormImport = withRouter(connect(mapStateToProps, mapDispatchToProps)(WizardFormImport));

export default reduxForm({form: 'import_posts'})(withTranslation('dashboard')(WizardFormImport));
